module.exports = __webpack_public_path__ + "img/weibo.4d8f6a64.png";